import RelationshipMetadata from "../../RelationshipMetadata";

class AdminWorkGroupAdminWorkGroupOrganizationRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "AdminWorkGroupAdminWorkGroupOrganizationRelationshipMetadata";
        this.parentEnterpriseComponent = "AdminWorkGroup";
        this.childEnterpriseComponent = "AdminWorkGroupOrganization";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "WorkGroupUSID";
    }
}

export default AdminWorkGroupAdminWorkGroupOrganizationRelationshipMetadata;